import { render, staticRenderFns } from "./client-show.html?vue&type=template&id=3fc2a926&scoped=true&"
import script from "./client-show.js?vue&type=script&lang=js&"
export * from "./client-show.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2a926",
  null
  
)

export default component.exports